// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__MvKn2","error":"textarea_error__PqK6r"};